
import operationLog from "./components/operation-log.vue";
import loginLog from "./components/login-log.vue";
import { Component, Vue } from "vue-property-decorator";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-operation-log": operationLog,
    "pi-login-log": loginLog
  }
})
export default class SystemConfigLog extends Vue {
  private tabsList: object[] = [
    { name: "tab1", title: i18n.t("log.tab1"), value: 1 },
    { name: "tab2", title: i18n.t("log.tab2"), value: 2 }
  ];
  private tabsActive = "tab1";
  public tabChange(data: string): void {
    this.tabsActive = data;
  }
}
